import { useAnimations, useGLTF } from '@react-three/drei';
import { Asset } from 'expo-asset';
import React, { useEffect, useRef, useState } from 'react';
import EXPRESSION_MAP from './expressionMap';
const model = require('./Pegasus.glb');
const abstractAsset = Asset.fromModule(model);

interface Props {
  expression?: keyof typeof EXPRESSION_MAP;
}

const Model = ({ expression, ...props }: Props) => {
  const group = useRef<any>();
  const { nodes, materials, animations } = useGLTF(abstractAsset.uri);
  const { actions } = useAnimations(animations, group);

  const [currentAction, setCurrentAction] = useState<string>(
    EXPRESSION_MAP[expression || 'default'] || 'Idle_01'
  );

  useEffect(() => {
    if (!actions || !currentAction) return;
    const expressionAnimation = actions[currentAction] || actions.Idle_01;

    expressionAnimation?.play();
  }, []);

  useEffect(() => {
    const newActionName = EXPRESSION_MAP[expression || 'default'] || 'Idle_01';

    const newAction = actions[newActionName];

    const currentAnimation = actions[currentAction] || actions.Idle_01;

    if (currentAnimation) {
      newAction?.reset();
      newAction?.crossFadeFrom(currentAnimation, 1, false).play();
    }

    setCurrentAction(newActionName);
  }, [expression]);

  return (
    <group ref={group} {...props} dispose={null}>
      <primitive object={nodes.Pegasus_All_AnimsRoot_M} />
      <skinnedMesh
        geometry={nodes.Pegasus_All_AnimsPegasus.geometry}
        material={materials['Pegasus_All_Anims:Pegasus_Mat']}
        skeleton={nodes.Pegasus_All_AnimsPegasus.skeleton}
      />
    </group>
  );
};

useGLTF.preload(abstractAsset.uri);

export default Model;
